import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Paper, TextField, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import amexOffers from '../services/amex_offers.service';

export default function AmexOffersPage() {
    const navigate = useNavigate();
    const [offers, setOffers] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [selectedUser, setSelectedUser] = useState('');
    const [users, setUsers] = useState([]);

    // Fetch unique users
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await amexOffers.getUniqueUsers();
                if (response.success) {
                    setUsers(response.result);
                } else {
                    console.error("Error fetching users:", response.message);
                }
            } catch (error) {
                console.error("Failed to fetch users:", error);
            }
        };

        fetchUsers();
    }, []);

    // Fetch offers whenever page, rowsPerPage, searchKeyword, or selectedUser changes
    useEffect(() => {
        fetchOffers(page + 1, rowsPerPage, searchKeyword, selectedUser);
    }, [page, rowsPerPage, searchKeyword, selectedUser]);

    const fetchOffers = async (page, pageSize, keyword, userId) => {
        try {
            const response = await amexOffers.getOffers(page, pageSize, keyword, userId);
            if (response.success) {
                setOffers(response.result.offers);
                setTotalCount(response.result.totalCount);
            } else {
                console.error("Error fetching offers:", response.message);
            }
        } catch (error) {
            console.error("Failed to fetch offers:", error);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchChange = (event) => {
        setSearchKeyword(event.target.value);
    };

    const handleUserChange = (event) => {
        setSelectedUser(event.target.value);
    };

    return (
        <div style={{ marginTop: "20px", width: "80%", margin: "auto" }}>
            <h1>AMEX OFFERS MANAGER</h1>
            <div style={{ marginBottom: "20px" }}>
                <TextField
                    label="Search"
                    variant="outlined"
                    value={searchKeyword}
                    onChange={handleSearchChange}
                    style={{ marginRight: "20px", width: "300px" }}
                />
                <FormControl variant="outlined" style={{ minWidth: 200 }}>
                    <InputLabel>User</InputLabel>
                    <Select
                        value={selectedUser}
                        onChange={handleUserChange}
                        label="User"
                    >
                        <MenuItem value=""><em>None</em></MenuItem>
                        {users.map((user, index) => (
                            <MenuItem key={index} value={user}>{user}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <span style={{ marginTop: "10px", marginLeft: '20px' }}>
                    <Button variant="contained" color="secondary" onClick={() => navigate('/amex-offers-downloads')}>
                        Go to download page
                    </Button>
                </span>
            </div>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Card Name</TableCell>
                            <TableCell>Card Identifier</TableCell>
                            <TableCell>Offer Name</TableCell>
                            <TableCell>Offer Body</TableCell>
                            <TableCell>Start Date</TableCell>
                            <TableCell>End Date</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {offers.map((offer) => (
                            <TableRow key={offer.id}>
                                <TableCell>{offer.cardName}</TableCell>
                                <TableCell>{offer.cardIdentifier}</TableCell>
                                <TableCell>{offer.offerName}</TableCell>
                                <TableCell>{offer.offerBody}</TableCell>
                                <TableCell>{offer.startDate}</TableCell>
                                <TableCell>{offer.endDate}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50]}
                    component="div"
                    count={totalCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </TableContainer>
        </div>
    );
}
